import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import VKGradeTables    from "./pages/VKGradeTables";
import VKQuestions      from "./pages/VKQuestions";
import VKTwoMarkPage    from "./pages/VKTwoMarkPage";
import VKTwoMarkPageSlide from "./pages/VKTwoMarkPageSlide";
import VKTwoMarkListPage  from "./pages/VKTwoMarkListPage";
import TamilLearningSlide from "./pages/TamilLearningSlide";
import TeacherTestSender  from "./pages/TeacherTestSender";
import MockTestPage       from "./pages/MockTestPage";
import MockTestResult     from "./pages/MockTestResult";
import SharedQuestionsPage from "./pages/SharedQuestionsPage";
import SharedTwoMarkPage   from "./pages/SharedTwoMarkPage";
import FBSchedulerPage     from "./pages/FBSchedulerPage";
import WASchedulerPage     from "./pages/WASchedulerPage";
import ReadingNotesPage    from "./pages/ReadingNotesPage";
import ReadingNotesAdmin   from "./pages/ReadingNotesAdmin";
import PreAlgebraPage      from "./pages/PreAlgebraPage";
import TnpscUnit1Page      from "./pages/TnpscUnit1Page";
import TnpscUnit2Page      from "./pages/TnpscUnit2Page";
import TnpscUnit3Page      from "./pages/TnpscUnit3Page";
import TnpscUnit4Page      from "./pages/TnpscUnit4Page";
import TnpscUnit5Page      from "./pages/TnpscUnit5Page";
import TnpscUnit6Page      from "./pages/TnpscUnit6Page";
import TnpscUnit7Page      from "./pages/TnpscUnit7Page";
import TnpscUnit8Page      from "./pages/TnpscUnit8Page";
import TnpscUnit9Page      from "./pages/TnpscUnit9Page";
import TnpscUnit10Page     from "./pages/TnpscUnit10Page";
import TnpscMenuPage       from "./pages/TnpscMenuPage";
import NeetPhysicsMenuPage from "./pages/NeetPhysicsMenuPage";
import NeetPhysicsCh1Page  from "./pages/NeetPhysicsCh1Page";
import NeetPhysicsCh2Page  from "./pages/NeetPhysicsCh2Page";
import NeetPhysicsCh3Page  from "./pages/NeetPhysicsCh3Page";
import NeetPhysicsCh4Page  from "./pages/NeetPhysicsCh4Page";
import NeetPhysicsCh5Page  from "./pages/NeetPhysicsCh5Page";
import NeetPhysicsCh6Page  from "./pages/NeetPhysicsCh6Page";
import NeetPhysicsCh7Page  from "./pages/NeetPhysicsCh7Page";
import NeetPhysicsCh8Page  from "./pages/NeetPhysicsCh8Page";
import NeetPhysicsCh9Page  from "./pages/NeetPhysicsCh9Page";
import NeetPhysicsCh10Page from "./pages/NeetPhysicsCh10Page";
import NeetPhysicsCh11Page from "./pages/NeetPhysicsCh11Page";
import NeetPhysicsCh12Page from "./pages/NeetPhysicsCh12Page";
import NeetPhysicsCh13Page from "./pages/NeetPhysicsCh13Page";
import NeetPhysicsCh14Page from "./pages/NeetPhysicsCh14Page";
import NeetPhysicsCh15Page from "./pages/NeetPhysicsCh15Page";
import NeetPhysicsCh16Page from "./pages/NeetPhysicsCh16Page";
import NeetPhysicsCh17Page from "./pages/NeetPhysicsCh17Page";
import NeetPhysicsCh18Page from "./pages/NeetPhysicsCh18Page";
import NeetPhysicsCh19Page from "./pages/NeetPhysicsCh19Page";
import NeetPhysicsCh20Page from "./pages/NeetPhysicsCh20Page";
import NeetPhysicsCh21Page from "./pages/NeetPhysicsCh21Page";
import NeetPhysicsCh22Page from "./pages/NeetPhysicsCh22Page";
import NeetPhysicsCh23Page from "./pages/NeetPhysicsCh23Page";
import NeetPhysicsCh24Page from "./pages/NeetPhysicsCh24Page";
import NeetPhysicsCh25Page from "./pages/NeetPhysicsCh25Page";
import NeetPhysicsCh26Page from "./pages/NeetPhysicsCh26Page";
import NeetPhysicsCh27Page from "./pages/NeetPhysicsCh27Page";
import NeetPhysicsCh28Page from "./pages/NeetPhysicsCh28Page";
import NeetPhysicsCh29Page from "./pages/NeetPhysicsCh29Page";
import CompetitiveExamsPage from "./pages/CompetitiveExamsPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/"               element={<VKGradeTables />} />
        <Route path="/grades"         element={<VKGradeTables />} />
        <Route path="/questions"      element={<VKQuestions />} />
        <Route path="/twomarks"       element={<VKTwoMarkPage />} />
        <Route path="/twomarksslide"  element={<VKTwoMarkPageSlide />} />
        <Route path="/oneWordNew"     element={<VKTwoMarkListPage />} />
        <Route path="/TamilLearningSlide" element={<TamilLearningSlide />} />
        <Route path="/sendtest"       element={<TeacherTestSender />} />
        <Route path="/mocktest"       element={<MockTestPage />} />
        <Route path="/mocktestresult" element={<MockTestResult />} />
        {/* Shared MCQ questions via WhatsApp link — IDs are encoded in ?q= param */}
        <Route path="/shared-questions" element={<SharedQuestionsPage />} />
        {/* Shared two-mark Q&A questions via WhatsApp link */}
        <Route path="/shared-twomark"   element={<SharedTwoMarkPage />} />
        {/* Admin: Facebook auto-post scheduler */}
        <Route path="/admin/fb-scheduler" element={<FBSchedulerPage />} />
        {/* Admin: WhatsApp question scheduler */}
        <Route path="/admin/wa-scheduler" element={<WASchedulerPage />} />
        {/* Daily Reading Notes — students */}
        <Route path="/reading"            element={<ReadingNotesPage />} />
        {/* Daily Reading Notes — teacher admin */}
        <Route path="/admin/reading-notes" element={<ReadingNotesAdmin />} />
        {/* Pre-Algebra (7th-grade math) — students */}
        <Route path="/prealgebra"          element={<PreAlgebraPage />} />
        <Route path="/pre-algebra"         element={<PreAlgebraPage />} />
        {/* TNPSC 554 — unit menu + per-unit concept guides */}
        <Route path="/tnpsc"               element={<TnpscMenuPage />} />
        <Route path="/tnpsc-unit1"         element={<TnpscUnit1Page />} />
        <Route path="/tnpsc-unit2"         element={<TnpscUnit2Page />} />
        <Route path="/tnpsc-unit3"         element={<TnpscUnit3Page />} />
        <Route path="/tnpsc-unit4"         element={<TnpscUnit4Page />} />
        <Route path="/tnpsc-unit5"         element={<TnpscUnit5Page />} />
        <Route path="/tnpsc-unit6"         element={<TnpscUnit6Page />} />
        <Route path="/tnpsc-unit7"         element={<TnpscUnit7Page />} />
        <Route path="/tnpsc-unit8"         element={<TnpscUnit8Page />} />
        <Route path="/tnpsc-unit9"         element={<TnpscUnit9Page />} />
        <Route path="/tnpsc-unit10"        element={<TnpscUnit10Page />} />
        {/* NEET Physics — chapter menu + per-chapter concept guides */}
        <Route path="/neet-physics"        element={<NeetPhysicsMenuPage />} />
        <Route path="/neet-physics-ch1"    element={<NeetPhysicsCh1Page />} />
        <Route path="/neet-physics-ch2"    element={<NeetPhysicsCh2Page />} />
        <Route path="/neet-physics-ch3"    element={<NeetPhysicsCh3Page />} />
        <Route path="/neet-physics-ch4"    element={<NeetPhysicsCh4Page />} />
        <Route path="/neet-physics-ch5"    element={<NeetPhysicsCh5Page />} />
        <Route path="/neet-physics-ch6"    element={<NeetPhysicsCh6Page />} />
        <Route path="/neet-physics-ch7"    element={<NeetPhysicsCh7Page />} />
        <Route path="/neet-physics-ch8"    element={<NeetPhysicsCh8Page />} />
        <Route path="/neet-physics-ch9"    element={<NeetPhysicsCh9Page />} />
        <Route path="/neet-physics-ch10"   element={<NeetPhysicsCh10Page />} />
        <Route path="/neet-physics-ch11"   element={<NeetPhysicsCh11Page />} />
        <Route path="/neet-physics-ch12"   element={<NeetPhysicsCh12Page />} />
        <Route path="/neet-physics-ch13"   element={<NeetPhysicsCh13Page />} />
        <Route path="/neet-physics-ch14"   element={<NeetPhysicsCh14Page />} />
        <Route path="/neet-physics-ch15"   element={<NeetPhysicsCh15Page />} />
        <Route path="/neet-physics-ch16"   element={<NeetPhysicsCh16Page />} />
        <Route path="/neet-physics-ch17"   element={<NeetPhysicsCh17Page />} />
        <Route path="/neet-physics-ch18"   element={<NeetPhysicsCh18Page />} />
        <Route path="/neet-physics-ch19"   element={<NeetPhysicsCh19Page />} />
        <Route path="/neet-physics-ch20"   element={<NeetPhysicsCh20Page />} />
        <Route path="/neet-physics-ch21"   element={<NeetPhysicsCh21Page />} />
        <Route path="/neet-physics-ch22"   element={<NeetPhysicsCh22Page />} />
        <Route path="/neet-physics-ch23"   element={<NeetPhysicsCh23Page />} />
        <Route path="/neet-physics-ch24"   element={<NeetPhysicsCh24Page />} />
        <Route path="/neet-physics-ch25"   element={<NeetPhysicsCh25Page />} />
        <Route path="/neet-physics-ch26"   element={<NeetPhysicsCh26Page />} />
        <Route path="/neet-physics-ch27"   element={<NeetPhysicsCh27Page />} />
        <Route path="/neet-physics-ch28"   element={<NeetPhysicsCh28Page />} />
        <Route path="/neet-physics-ch29"   element={<NeetPhysicsCh29Page />} />
        {/* Competitive Examinations — hub page linking to TNPSC 554 + NEET Physics */}
        <Route path="/competitive-examinations" element={<CompetitiveExamsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
